import { AuthorizeService } from "./AuthorizeService";

export { AuthorizeService };
